import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-phone-icon',
	templateUrl: './phone-icon.component.html',
})
export class PhoneIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
